(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-honey-booking]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const service = section.querySelector('[data-booking-service]');
      const location = section.querySelector('[data-booking-location]');
      const date = section.querySelector('[data-booking-date]');
      const parts = new Intl.DateTimeFormat('en', {timeZone:'Asia/Riyadh',year:'numeric',month:'2-digit',day:'2-digit'}).formatToParts(new Date());
      const part = name => parts.find(p => p.type === name).value;
      date.min = `${part('year')}-${part('month')}-${part('day')}`;
      const show = (selector, visible) => {
        const wrapper = section.querySelector(selector);
        wrapper.hidden = !visible;
        wrapper.querySelectorAll('input').forEach(input => {input.disabled = !visible; input.required = visible;});
      };
      const update = () => {
        show('[data-booking-neighbourhood]', location.selectedOptions[0]?.dataset.home === 'true');
        show('[data-booking-group]', service.selectedOptions[0]?.dataset.kind === 'group');
      };
      service.addEventListener('change', update);
      location.addEventListener('change', update);
      update();
      // Allow a dedicated service page to pre-select its experience via ?service=NAME.
      const wanted = new URLSearchParams(window.location.search).get('service');
      if (wanted) {
        const match = [...service.options].find(o => o.value && o.value.trim().toLowerCase() === wanted.trim().toLowerCase());
        if (match) { service.value = match.value; update(); }
      }
      // Native Shopify contact submission owns delivery and server responses.
      // No client-only success state, availability or reservation is fabricated.
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target.parentNode));
})();
